"use strict";
/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var XML_GramaticaDesc = (function () {
    var o = function (k, v, o, l) { for (o = o || {}, l = k.length; l--; o[k[l]] = v)
        ; return o; }, $V0 = [2, 5], $V1 = [1, 9], $V2 = [1, 13], $V3 = [1, 17], $V4 = [2, 9], $V5 = [1, 16], $V6 = [5, 6], $V7 = [7, 10, 21], $V8 = [2, 7, 10, 14, 21], $V9 = [1, 46], $Va = [2, 21], $Vb = [1, 39], $Vc = [1, 35], $Vd = [1, 36], $Ve = [1, 37], $Vf = [1, 38], $Vg = [1, 40], $Vh = [1, 41], $Vi = [1, 42], $Vj = [1, 43], $Vk = [1, 44], $Vl = [1, 45], $Vm = [2, 6, 8, 14, 25, 26, 27, 28, 29, 30, 31, 32, 33], $Vn = [1, 52];
    var parser = { trace: function trace() { },
        yy: {},
        symbols_: { "error": 2, "START": 3, "ENCABEZADO": 4, "EOF": 5, "lt": 6, "interrog": 7, "xml": 8, "LISTAATRIBUTOS": 9, "gt": 10, "LISTAELEMENTOS": 11, "ELEMENTO": 12, "ELEM": 13, "identifier": 14, "TIPOELEM": 15, "ATRIBUTO": 16, "asig": 17, "TIPOCADENA": 18, "cadena": 19, "cadena2": 20, "diag": 21, "TEXTCONTENT": 22, "MOREELEMENTS": 23, "TEXT": 24, "content": 25, "DoubleLiteral": 26, "IntegerLiteral": 27, "apos": 28, "less": 29, "greater": 30, "ampersand": 31, "apostrophe": 32, "quot": 33, "$accept": 0, "$end": 1 },
        terminals_: { 2: "error", 5: "EOF", 6: "lt", 7: "interrog", 8: "xml", 10: "gt", 14: "identifier", 17: "asig", 19: "cadena", 20: "cadena2", 21: "diag", 25: "content", 26: "DoubleLiteral", 27: "IntegerLiteral", 28: "apos", 29: "less", 30: "greater", 31: "ampersand", 32: "apostrophe", 33: "quot" },
        productions_: [0, [3, 2], [4, 7], [4, 2], [11, 2], [11, 0], [12, 2], [13, 3], [9, 2], [9, 0], [16, 3], [16, 2], [16, 2], [18, 1], [18, 1], [15, 2], [15, 4], [15, 3], [23, 3], [23, 3], [22, 2], [22, 0], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1], [24, 1]],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
            /* this == yyval */
            var $0 = $$.length - 1;
            switch (yystate) {
                case 1:
                    let raiz = new Nodo(cst.cstXmlDesc.getId(), 'START', null, [cst.cstXmlDesc.obtenerUltimoNodo()]);
                    cst.cstXmlDesc.setRaiz(raiz);
                    return $$[$0 - 1];
                    break;
                case 2:
                    $$[$0].unshift(new Objeto($$[$0 - 4], '', _$[$0 - 6].first_line, _$[$0 - 6].first_column, $$[$0 - 3], [], true));
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    let listaElem2 = cst.cstXmlDesc.obtenerUltimoNodo();
                    let listAtrs3 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ENCABEZADO', null, [new Nodo(cst.cstXmlDesc.getId(), 'lt', null, [new Nodo(cst.cstXmlDesc.getId(), '<', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'interrog', null, [new Nodo(cst.cstXmlDesc.getId(), '?', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'xml', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0 - 4].toString(), null, [])]),
                        listAtrs3,
                        new Nodo(cst.cstXmlDesc.getId(), 'interrog', null, [new Nodo(cst.cstXmlDesc.getId(), '?', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'gt', null, [new Nodo(cst.cstXmlDesc.getId(), '>', null, [])]),
                        listaElem2]));
                    break;
                case 3:
                    errores.default.agregarError('sintáctico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ENCABEZADO', null, [new Nodo(cst.cstXmlDesc.getId(), 'error', null, []),
                        cst.cstXmlDesc.obtenerUltimoNodo()]));
                    break;
                case 4:
                    $$[$0 - 1] = $$[$0 - 1].concat($$[$0]);
                    this.$ = $$[$0 - 1];
                    /* CONSTRUCCION DE CST */
                    let listaElem = cst.cstXmlDesc.obtenerUltimoNodo();
                    let elem2 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'LISTAELEMENTOS', null, [elem2, listaElem]));
                    break;
                case 5:
                    this.$ = [];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'LISTAELEMENTOS', null, [new Nodo(cst.cstXmlDesc.getId(), 'epsilon', null, [])]));
                    break;
                case 6:
                    this.$ = [$$[$0]];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ELEMENTO', null, [new Nodo(cst.cstXmlDesc.getId(), 'lt', null, [new Nodo(cst.cstXmlDesc.getId(), '<', null, [])]),
                        cst.cstXmlDesc.obtenerUltimoNodo()]));
                    break;
                case 7:
                    let newObj = null;
                    if ($$[$0] !== null) {
                        if ($$[$0].idCierre === '' && $$[$0].texto === '' && $$[$0].content === null) { /** Etiqueta unica */
                            newObj = new Objeto($$[$0 - 2], '', _$[$0 - 2].first_line, _$[$0 - 2].first_column, $$[$0 - 1], [], true);
                        }
                        else if ($$[$0].idCierre !== '') { /** Etiqueta doble */
                            if ($$[$0 - 2] === $$[$0].idCierre) {
                                //newObj = new Objeto($$[$0-2], $$[$0].texto, _$[$0-2].first_line, _$[$0-2].first_column, $$[$0-1], $$[$0].content !=== null?$$[$0].content:[], false);
                                if ($$[$0].content !== null) /** El contenido es mas objetos */
                                    newObj = new Objeto($$[$0 - 2], '', _$[$0 - 2].first_line, _$[$0 - 2].first_column, $$[$0 - 1], $$[$0].content, false);
                                else if ($$[$0].texto !== '') /** El contenido es un texto */
                                    newObj = new Objeto($$[$0 - 2], $$[$0].texto, _$[$0 - 2].first_line, _$[$0 - 2].first_column, $$[$0 - 1], [], false);
                                else
                                    newObj = new Objeto($$[$0 - 2], '', _$[$0 - 2].first_line, _$[$0 - 2].first_column, $$[$0 - 1], [], false);
                            }
                            else {
                                console.log('Linea 85: Error semantico: Las etiquetas deben ser iguales');
                                errores.default.agregarError('semantico', 'Las etiquetas deben ser iguales', _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                            }
                        }
                    }
                    this.$ = newObj;
                    /* CONSTRUCCION DE CST */
                    let tElement = cst.cstXmlDesc.obtenerUltimoNodo();
                    let listAtrs2 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ELEM', null, [new Nodo(cst.cstXmlDesc.getId(), 'identifier', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0 - 2].toString(), null, [])]),
                        listAtrs2, tElement]));
                    break;
                case 8:
                    if ($$[$0 - 1] !== null) {
                        $$[$0 - 1] = $$[$0 - 1].concat($$[$0]);
                        this.$ = $$[$0 - 1];
                    }
                    else
                        this.$ = $$[$0];
                    /* CONSTRUCCION DE CST */
                    let listAtrs = cst.cstXmlDesc.obtenerUltimoNodo();
                    let atr = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'LISTAATRIBUTOS', null, [atr, listAtrs]));
                    break;
                case 9:
                    this.$ = [];
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'LISTAATRIBUTOS', null, [new Nodo(cst.cstXmlDesc.getId(), 'epsilon', null, [])]));
                    break;
                case 10:
                    this.$ = [new Atributo($$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column)];
                    break;
                case 11:
                    console.log('Entra a error sintactico de atributo');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = null;
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ATRIBUTO', null, [new Nodo(cst.cstXmlDesc.getId(), 'identifier', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0 - 1].toString(), null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'asignacion', null, [new Nodo(cst.cstXmlDesc.getId(), '=', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), cst.cstXmlDesc.obtenerUltimoNodo(), null, [])]));
                    break;
                case 12:
                    console.log('Entra a error sintactico de atributo 2');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = null;
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'ATRIBUTO', null, [new Nodo(cst.cstXmlDesc.getId(), 'error', null, []),
                        new Nodo(cst.cstXmlDesc.getId(), 'lt', null, [new Nodo(cst.cstXmlDesc.getId(), '<', null, [])])]));
                    break;
                case 13:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TIPOCADENA', null, [new Nodo(cst.cstXmlDesc.getId(), 'cadena', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 14:
                    this.$ = $$[$0].toString().replaceAll("'", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TIPOCADENA', null, [new Nodo(cst.cstXmlDesc.getId(), 'cadena', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("'", ""), null, [])])]));
                    break;
                case 15:
                    this.$ = { 'texto': '', 'content': null, 'idCierre': '' };
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TIPOELEM', null, [new Nodo(cst.cstXmlDesc.getId(), 'diag', null, [new Nodo(cst.cstXmlDesc.getId(), '/', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'gt', null, [new Nodo(cst.cstXmlDesc.getId(), '>', null, [])])]));
                    break;
                case 16:
                    if ($$[$0].idCierre !== '') {
                        if ($$[$0 - 2] !== '') /* Etiqueta con texto*/
                            $$[$0].texto = $$[$0 - 2];
                        this.$ = $$[$0];
                    }
                    /* CONSTRUCCION DE CST */
                    let mElem2 = cst.cstXmlDesc.obtenerUltimoNodo();
                    let textContent2 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TIPOELEM', null, [new Nodo(cst.cstXmlDesc.getId(), 'gt', null, [new Nodo(cst.cstXmlDesc.getId(), '>', null, [])]),
                        textContent2,
                        new Nodo(cst.cstXmlDesc.getId(), 'lt', null, [new Nodo(cst.cstXmlDesc.getId(), '<', null, [])]),
                        mElem2]));
                    break;
                case 17:
                    console.log('Entra a error sintactico de TIPOELEM');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    this.$ = null;
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TIPOELEM', null, [new Nodo(cst.cstXmlDesc.getId(), 'diag', null, [new Nodo(cst.cstXmlDesc.getId(), '/', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'error', null, []),
                        new Nodo(cst.cstXmlDesc.getId(), 'gt', null, [new Nodo(cst.cstXmlDesc.getId(), '>', null, [])])]));
                    break;
                case 18:
                    this.$ = { 'texto': '', 'content': null, 'idCierre': $$[$0 - 1] };
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'MOREELEMENTS', null, [new Nodo(cst.cstXmlDesc.getId(), 'diag', null, [new Nodo(cst.cstXmlDesc.getId(), '/', null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'identifier', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0 - 1].toString().replaceAll("\"", ""), null, [])]),
                        new Nodo(cst.cstXmlDesc.getId(), 'gt', null, [new Nodo(cst.cstXmlDesc.getId(), '>', null, [])])]));
                    break;
                case 19:
                    if ($$[$0].idCierre !== '') { /** Se esta cerrando una etiqueta y se comienza a subir **/
                        if ($$[$0 - 2] instanceof Objeto) {
                            if ($$[$0].content === null)
                                this.$ = { 'texto': '', 'content': [$$[$0 - 2]], 'idCierre': $$[$0].idCierre };
                            else {
                                $$[$0].content.unshift($$[$0 - 2]);
                                this.$ = { 'texto': '', 'content': $$[$0].content, 'idCierre': $$[$0].idCierre };
                            }
                        }
                        else if ($$[$0 - 2] === null) {
                            this.$ = $$[$0];
                        }
                        else {
                        }
                    }
                    /* CONSTRUCCION DE CST */
                    let mElem1 = cst.cstXmlDesc.obtenerUltimoNodo();
                    let elem1 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'MOREELEMENTS', null, [elem1,
                        new Nodo(cst.cstXmlDesc.getId(), 'lt', null, [new Nodo(cst.cstXmlDesc.getId(), '<', null, [])]),
                        mElem1]));
                    break;
                case 20:
                    $$[$0 - 1] = $$[$0 - 1] + $$[$0];
                    this.$ = $$[$0 - 1];
                    /* CONSTRUCCION DE CST */
                    let textContent = cst.cstXmlDesc.obtenerUltimoNodo();
                    let t1 = cst.cstXmlDesc.obtenerUltimoNodo();
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXTCONTENT', null, [t1, textContent]));
                    break;
                case 21:
                    this.$ = '';
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXTCONTENT', null, [new Nodo(cst.cstXmlDesc.getId(), 'epsilon', null, [])]));
                    break;
                case 22:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'identificador', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 23:
                    this.$ = $$[$0].toString();
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'content', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 24:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'double', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 25:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'integer', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 26:
                    this.$ = $$[$0].toString();
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'identificador', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 27:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'comilla simple', null, [new Nodo(cst.cstXmlDesc.getId(), $$[$0].toString().replaceAll("\"", ""), null, [])])]));
                    break;
                case 28:
                    this.$ = "<";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'menor que', null, [new Nodo(cst.cstXmlDesc.getId(), "<", null, [])])]));
                    break;
                case 29:
                    this.$ = ">";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'mayor que', null, [new Nodo(cst.cstXmlDesc.getId(), ">", null, [])])]));
                    break;
                case 30:
                    this.$ = "&";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'ampersand', null, [new Nodo(cst.cstXmlDesc.getId(), "&", null, [])])]));
                    break;
                case 31:
                    this.$ = "'";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'apostrofe', null, [new Nodo(cst.cstXmlDesc.getId(), "'", null, [])])]));
                    break;
                case 32:
                    this.$ = "\"";
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, [new Nodo(cst.cstXmlDesc.getId(), 'comilla doble', null, [new Nodo(cst.cstXmlDesc.getId(), '"', null, [])])]));
                    break;
                case 33:
                    this.$ = $$[$0].toString().replaceAll("\"", "");
                    /* CONSTRUCCION DE CST */
                    cst.cstXmlDesc.agregarPila(new Nodo(cst.cstXmlDesc.getId(), 'TEXT', null, []));
                    break;
            }
        },
        table: [{ 2: [1, 4], 3: 1, 4: 2, 6: [1, 3] }, { 1: [3] }, { 5: [1, 5] }, { 7: [1, 6] }, { 5: $V0, 6: $V1, 11: 7, 12: 8 }, { 1: [2, 1] }, { 8: [1, 10] }, { 5: [2, 3] }, { 5: $V0, 6: $V1, 11: 11, 12: 8 }, { 13: 12, 14: $V2 }, { 2: $V3, 7: $V4, 9: 14, 14: $V5, 16: 15 }, { 5: [2, 4] }, o($V6, [2, 6]), o([10, 21], $V4, { 16: 15, 9: 18, 2: $V3, 14: $V5 }), { 7: [1, 19] }, o($V7, $V4, { 16: 15, 9: 20, 2: $V3, 14: $V5 }), { 17: [1, 21] }, { 6: [1, 23], 10: [1, 22] }, { 10: [1, 26], 15: 24, 21: [1, 25] }, { 10: [1, 27] }, o($V7, [2, 8]), { 18: 28, 19: [1, 29], 20: [1, 30] }, o($V8, [2, 11]), o($V8, [2, 12]), o($V6, [2, 7]), { 2: [1, 32], 10: [1, 31] }, { 2: $V9, 6: $Va, 8: $Vb, 14: $Vc, 22: 33, 24: 34, 25: $Vd, 26: $Ve, 27: $Vf, 28: $Vg, 29: $Vh, 30: $Vi, 31: $Vj, 32: $Vk, 33: $Vl }, { 5: $V0, 6: $V1, 11: 47, 12: 8 }, o($V8, [2, 10]), o($V8, [2, 13]), o($V8, [2, 14]), o($V6, [2, 15]), { 10: [1, 48] }, { 6: [1, 49] }, { 2: $V9, 6: $Va, 8: $Vb, 14: $Vc, 22: 50, 24: 34, 25: $Vd, 26: $Ve, 27: $Vf, 28: $Vg, 29: $Vh, 30: $Vi, 31: $Vj, 32: $Vk, 33: $Vl }, o($Vm, [2, 22]), o($Vm, [2, 23]), o($Vm, [2, 24]), o($Vm, [2, 25]), o($Vm, [2, 26]), o($Vm, [2, 27]), o($Vm, [2, 28]), o($Vm, [2, 29]), o($Vm, [2, 30]), o($Vm, [2, 31]), o($Vm, [2, 32]), o($Vm, [2, 33]), { 5: [2, 2] }, o($V6, [2, 17]), { 13: 53, 14: $V2, 21: $Vn, 23: 51 }, { 6: [2, 20] }, o($V6, [2, 16]), { 14: [1, 54] }, { 6: [1, 55] }, { 10: [1, 56] }, { 13: 53, 14: $V2, 21: $Vn, 23: 57 }, o($V6, [2, 18]), o($V6, [2, 19])],
        defaultActions: { 5: [2, 1], 7: [2, 3], 11: [2, 4], 47: [2, 2], 50: [2, 20] },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) {
                this.trace(str);
            }
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [0], tstack = [], // token stack
            vstack = [null], // semantic value stack
            lstack = [], // location stack
            table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            //this.reductionCount = this.shiftCount = 0;
            var lexer = Object.create(this.lexer);
            var sharedState = { yy: {} };
            // copy state
            for (var k in this.yy) {
                if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
                    sharedState.yy[k] = this.yy[k];
                }
            }
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') {
                lexer.yylloc = {};
            }
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') {
                this.parseError = sharedState.yy.parseError;
            }
            else {
                this.parseError = Object.getPrototypeOf(this).parseError;
            }
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function () {
                var token;
                token = lexer.lex() || EOF;
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') {
                    token = self.symbols_[token] || token;
                }
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while (true) {
                // retreive state number from top of stack
                state = stack[stack.length - 1];
                // use default actions if available
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                }
                else {
                    if (symbol === null || typeof symbol == 'undefined') {
                        symbol = lex();
                    }
                    // read action for current state and first input
                    action = table[state] && table[state][symbol];
                }
                _handle_error: 
                // handle parse error
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var error_rule_depth;
                    var errStr = '';
                    // Return the rule stack depth where the nearest error rule can be found.
                    // Return FALSE when no error recovery rule was found.
                    function locateNearestErrorRecoveryRule(state) {
                        var stack_probe = stack.length - 1;
                        var depth = 0;
                        // try to recover from error
                        for (;;) {
                            // check for error recovery rule in this state
                            if ((TERROR.toString()) in table[state]) {
                                return depth;
                            }
                            if (state === 0 || stack_probe < 2) {
                                return false; // No suitable error recovery rule available.
                            }
                            stack_probe -= 2; // popStack(1): [symbol, action]
                            state = stack[stack_probe];
                            ++depth;
                        }
                    }
                    if (!recovering) {
                        // first see if there's any chance at hitting an error recovery rule:
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                        // Report error
                        expected = [];
                        for (p in table[state]) {
                            if (this.terminals_[p] && p > TERROR) {
                                expected.push("'" + this.terminals_[p] + "'");
                            }
                        }
                        if (lexer.showPosition) {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        }
                        else {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ": Unexpected " +
                                (symbol == EOF ? "end of input" :
                                    ("'" + (this.terminals_[symbol] || symbol) + "'"));
                        }
                        this.parseError(errStr, {
                            text: lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: lexer.yylineno,
                            loc: yyloc,
                            expected: expected,
                            recoverable: (error_rule_depth !== false)
                        });
                    }
                    else if (preErrorSymbol !== EOF) {
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                    }
                    // just recovered from another error
                    if (recovering == 3) {
                        if (symbol === EOF || preErrorSymbol === EOF) {
                            throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                        }
                        // discard current lookahead and grab another
                        yyleng = lexer.yyleng;
                        yytext = lexer.yytext;
                        yylineno = lexer.yylineno;
                        yyloc = lexer.yylloc;
                        symbol = lex();
                    }
                    // try to recover from error
                    if (error_rule_depth === false) {
                        throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
                    }
                    popStack(error_rule_depth);
                    preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
                    symbol = TERROR; // insert generic error symbol as new lookahead
                    state = stack[stack.length - 1];
                    action = table[state] && table[state][TERROR];
                    recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                }
                // this shouldn't happen, unless resolve defaults are off
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                }
                switch (action[0]) {
                    case 1: // shift
                        //this.shiftCount++;
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]); // push state
                        symbol = null;
                        if (!preErrorSymbol) { // normal execution/no error
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) {
                                recovering--;
                            }
                        }
                        else {
                            // error just occurred, resume old lookahead f/ before error
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        // reduce
                        //this.reductionCount++;
                        len = this.productions_[action[1]][1];
                        // perform semantic action
                        yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
                        // default location, uses first token for firsts, last for lasts
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) {
                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                        }
                        r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
                        if (typeof r !== 'undefined') {
                            return r;
                        }
                        // pop off stack
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        // goto new state = table[STATE][NONTERMINAL]
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        // accept
                        return true;
                }
            }
            return true;
        } };
    //const Nodo = require("./AST/nodo_arbol");
    //var raiz;
    const { Objeto } = require("../XML/Objeto");
    const { Atributo } = require("../XML/Atributo");
    const errores = require('../Global/ListaError');
    const { Nodo } = require('../Reporte/Nodo');
    const cst = require('../Reporte/CST');
    /* generated by jison-lex 0.3.4 */
    var lexer = (function () {
        var lexer = ({
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) {
                    this.yy.parser.parseError(str, hash);
                }
                else {
                    throw new Error(str);
                }
            },
            // resets the lexer, sets new input
            setInput: function (input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) {
                    this.yylloc.range = [0, 0];
                }
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function () {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                }
                else {
                    this.yylloc.last_column++;
                }
                if (this.options.ranges) {
                    this.yylloc.range[1]++;
                }
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function (ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) {
                    this.yylineno -= lines.length - 1;
                }
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ?
                        (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                            + oldLines[oldLines.length - lines.length].length - lines[0].length :
                        this.yylloc.first_column - len
                };
                if (this.options.ranges) {
                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
                }
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function () {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function () {
                if (this.options.backtrack_lexer) {
                    this._backtrack = true;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
                return this;
            },
            // retain first n characters of the match
            less: function (n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function () {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function () {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20 - next.length);
                }
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function () {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function (match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) {
                        backup.yylloc.range = this.yylloc.range.slice(0);
                    }
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno += lines.length;
                }
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ?
                        lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                        this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) {
                    this.yylloc.range = [this.offset, this.offset += this.yyleng];
                }
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) {
                    this.done = false;
                }
                if (token) {
                    return token;
                }
                else if (this._backtrack) {
                    // recover context
                    for (var k in backup) {
                        this[k] = backup[k];
                    }
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function () {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) {
                    this.done = true;
                }
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i = 0; i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) {
                                return token;
                            }
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            }
                            else {
                                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                                return false;
                            }
                        }
                        else if (!this.options.flex) {
                            break;
                        }
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) {
                        return token;
                    }
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") {
                    return this.EOF;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) {
                    return r;
                }
                else {
                    return this.lex();
                }
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    return this.conditionStack.pop();
                }
                else {
                    return this.conditionStack[0];
                }
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                }
                else {
                    return this.conditions["INITIAL"].rules;
                }
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) {
                    return this.conditionStack[n];
                }
                else {
                    return "INITIAL";
                }
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {},
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch ($avoiding_name_collisions) {
                    case 0:
                        this.begin('comment');
                        break;
                    case 1:
                        this.popState();
                        break;
                    case 2: /* skip comment content*/
                        break;
                    case 3: /* skip whitespace */
                        break;
                    case 4:
                        return 6;
                        break;
                    case 5:
                        return 10;
                        break;
                    case 6:
                        return 17;
                        break;
                    case 7:
                        return 21;
                        break;
                    case 8:
                        return 7;
                        break;
                    case 9:
                        return 28;
                        break;
                    case 10:
                        return "xml";
                        break;
                    case 11:
                        return 29;
                        break;
                    case 12:
                        return 30;
                        break;
                    case 13:
                        return 31;
                        break;
                    case 14:
                        return "apostrophe";
                        break;
                    case 15:
                        return "quot";
                        break;
                    case 16:
                        return 26;
                        break;
                    case 17:
                        return 27;
                        break;
                    case 18:
                        return 14;
                        break;
                    case 19:
                        return 19;
                        break;
                    case 20:
                        return 20;
                        break;
                    case 21:
                        return 25;
                        break;
                    case 22:
                        return 5;
                        break;
                    case 23:
                        errores.default.agregarError('lexico', 'Simbolo inesperado ' + yy_.yytext, yy_.yylloc.first_line, yy_.yylloc.first_column);
                        break;
                }
            },
            rules: [/^(?:<!--)/, /^(?:-->)/, /^(?:.)/, /^(?:\s+)/, /^(?:<)/, /^(?:>)/, /^(?:=)/, /^(?:\/)/, /^(?:\?)/, /^(?:')/, /^(?:[xX][mM][lL])/, /^(?:&lt;)/, /^(?:&gt;)/, /^(?:&amp;)/, /^(?:&apos;)/, /^(?:&quot;)/, /^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/, /^(?:[0-9]+)/, /^(?:[a-zA-Z_][a-zA-Z0-9_ñÑ.-]*)/, /^(?:("((\\([\'\"\\]))|([^\"\\]+))*"))/, /^(?:('((\\([\'\"\\]))|([^\'\\]))*'))/, /^(?:([^<]))/, /^(?:$)/, /^(?:.)/],
            conditions: { "comment": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], "inclusive": true }, "INITIAL": { "rules": [0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], "inclusive": true } }
        });
        return lexer;
    })();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
})();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
    exports.parser = XML_GramaticaDesc;
    exports.Parser = XML_GramaticaDesc.Parser;
    exports.parse = function () { return XML_GramaticaDesc.parse.apply(XML_GramaticaDesc, arguments); };
    exports.main = function commonjsMain(args) {
        if (!args[1]) {
            console.log('Usage: ' + args[0] + ' FILE');
            process.exit(1);
        }
        var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
        return exports.parser.parse(source);
    };
    if (typeof module !== 'undefined' && require.main === module) {
        exports.main(process.argv.slice(1));
    }
}
